import { create } from 'zustand';
import { AccountApi, ApiUtils, type StoreBaseReturn } from '@shared/api';

interface UseApproveRequestStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  approveRequest: (requestId: string, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useApproveRequestStore = create<UseApproveRequestStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  approveRequest: async (requestId, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await AccountApi.approveRequest(requestId, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
